<script>
    import moment from "moment";
    import addWidgetModal from './add-widget-modal.vue';
    import deleteWidgetModal from './delete-widget-modal.vue';
    import widgetsList from './widgets-list.vue';
    import widgetsSearch from './widgets-search.vue';
    import WidgetsHeader from "./widgets-header.vue";
    import WidgetsActions from "./widgets-actions.vue";
    import Loading from "../../common/loading.vue";
    import DisableWidgetDialog from "./disable-widget-dialog.vue";

    const DATE_FORMAT_MAPPING = {
        'dd.MM.yyyy': 'DD.MM.yyyy',
        'MM/dd/yyyy': 'MM.DD.yyyy'
    };

    export default {
        name: 'widgets',
        props: {
            manageWidgetsPrivilegeString: {},
            viewWidgetsPrivilegeString: {},
            superadminPrivilegeString: {}
        },
        components: {
            DisableWidgetDialog,
            Loading,
            WidgetsActions,
            WidgetsHeader,
            addWidgetModal,
            deleteWidgetModal,
            widgetsList,
            widgetsSearch,
        },
        data() {
            return {
                files: [],
                loading: true,
                selectedWidgets: {
                    names: [],
                    ids: []
                },
                mode: 'tiles',
                sort_by: '',
                sort_dir: 'asc',
                widgets: [],
            }
        },
        computed: {
            widgetsCount() {
                if (this.loading) return undefined;

                return this.widgets.length;
            },
            translations() {
                return {
                    title: Lang.langChoice("Widget|Widgets", 2),
                    notLoaded: Lang.langGet("The widgets are not loaded."),
                }
            },
            manageWidgetsPrivilege() {
                return this.manageWidgetsPrivilegeString.includes('1');
            },
            superadminPrivilege() {
                return this.superadminPrivilegeString.includes('1');
            },
            displayDeleteButton() {
                return !!this.selectedWidgets.ids.length;
            }
        },
        methods: {
            fetchWidgets(data) {
                this.loading = true;
                this.widgets = [];

                axios.post('/administration/widget/get', {
                    id: Laravel.activeProject,
                    keyword: data?.keyword,
                }).then((response) => {
                    this.loading = false;
                    this.widgets = response.data.data.widgets;
                    this.selectedWidgets = {
                        names: [],
                        ids: []
                    };
                }).catch((error) => {
                    this.loading = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                });
            },
            sortWidgets(data) {
                if (data) {
                    this.sort_by = data.sort_by;
                    this.sort_dir = data.sort_dir;
                }
                this.widgets.sort((widget1, widget2) => {
                    let val1, val2;
                    if (this.sort_by === 'date') {
                        const currentDateFormat = DATE_FORMAT_MAPPING[Laravel.activeDateformat];
                        val1 = moment(widget1.created_at, currentDateFormat).unix();
                        val2 = moment(widget2.created_at, currentDateFormat).unix();
                    } else if (this.sort_by === 'type') {
                        val1 = (widget1.name + " " + widget1.file_name).toLowerCase();
                        val2 = (widget2.name + " " + widget2.file_name).toLowerCase();
                    } else {
                        val1 = widget1.name.toLowerCase();
                        val2 = widget2.name.toLowerCase();
                    }
                    let retVal = 0;
                    if(val1 > val2)
                        retVal = this.sort_dir === 'desc' ? -1 : 1;
                    else if(val1 < val2)
                        retVal = this.sort_dir === 'desc' ? 1 : -1;

                    return retVal;
                });
            },
            changeMode() {
                this.selectedWidgets = {
                    names: [],
                    ids: []
                };

                this.mode = this.mode === 'tiles' ? 'list' : 'tiles';
                localStorage.setItem('widgets-mode-' + Laravel.activeProject, this.mode);
                EaseEventBus.fire('widgetsMode', this.mode);
            },
            showAddWidgetModal(global) {
                EaseEventBus.fire('showAddWidgetModal', global);
            },
            showDeleteWidgetModal() {
                EaseEventBus.fire('multiDeleteWidget', this.selectedWidgets);
            },
            showDisableWidgetModal() {
                EaseEventBus.fire('showDisableWidgetDialog', this.selectedWidgets);
            }
        },
        mounted() {
            this.fetchWidgets();
            this.mode = localStorage.getItem('widgets-mode-' + Laravel.activeProject) ?? 'tiles';

            EaseEventBus.listen('selectWidgets', (data) => {
                this.$nextTick(() => {
                    if (data.selected) {
                        this.selectedWidgets.ids.push(data.id);
                        this.selectedWidgets.names.push(data.name);
                    } else {
                        const i = this.selectedWidgets.ids.indexOf(data.id);
                        if(i >= 0) {
                            this.selectedWidgets.ids.splice(i, 1);
                            this.selectedWidgets.names.splice(i, 1);
                        }
                    }
                });
            });

            EaseEventBus.listen('updateWidgetlistData', (data) => {
                this.fetchWidgets(data);
            });

            EaseEventBus.listen('startSearch', (data) => {
                this.fetchWidgets(data);
            });

            EaseEventBus.listen('sortBy', (data) => {
                this.sortWidgets(data);
            });
        }
    }
</script>

<template>
    <div class="px-5">
        <loading :loading="loading"/>
        <widgets-header :count="widgetsCount">
            <widgets-search />

            <widgets-actions
                :mode="mode"
                :manageWidgetsPrivilege="manageWidgetsPrivilege"
                :superadminPrivilege="superadminPrivilege"
                :displayDeleteButton="displayDeleteButton"
                @click="changeMode"
                @delete="showDeleteWidgetModal"
                @add="showAddWidgetModal"
                @disable="showDisableWidgetModal"
            />
        </widgets-header>

        <widgets-list
            :widgets="widgets"
            :view-privilege="viewWidgetsPrivilegeString"
            :manage-privilege="manageWidgetsPrivilegeString"
        />

        <add-widget-modal v-if="manageWidgetsPrivilege"/>
        <delete-widget-modal v-if="manageWidgetsPrivilege"/>
        <disable-widget-dialog v-if="manageWidgetsPrivilege"/>
    </div>
</template>
